import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockFoundationModelInputModalities,
  BedrockFoundationModelLifecycleStatus,
  BedrockFoundationModelOutputModalities,
  BedrockFoundationModelProvider,
  BedrockModelARN,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockFoundationModelMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state="None"
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt="None"
      />
      {BedrockFoundationModelInputModalities(metadata)}
      {BedrockFoundationModelOutputModalities(metadata)}
      {BedrockFoundationModelLifecycleStatus(metadata)}
      {BedrockModelARN(metadata)}
      {BedrockFoundationModelProvider(metadata)}
    </Grid>
  );
};
